export const comprimirImagen = (imagenComoArchivo:Blob, porcentajeCalidad=50) => {

    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const imagen = new Image();
      imagen.onload = () => {
        canvas.width = imagen.width;
        canvas.height = imagen.height;
        canvas!.getContext("2d")!.drawImage(imagen, 0, 0);
        canvas.toBlob(
          (blob) => {
            if (blob === null) {
              return reject(blob);
            } else {
              resolve(blob);
            }
          },
          "image/jpeg",
          porcentajeCalidad / 100
        );
      };
      imagen.src = URL.createObjectURL(imagenComoArchivo);
    });
  };

/**
 * Optimiza una imagen para documentos de contenedores manteniendo buena calidad para códigos
 * @param {Blob} imageBlob - La imagen original a comprimir
 * @returns {Promise<Blob>} - La imagen comprimida
 */
export const optimizeImage = async (imageBlob:Blob):Promise<Blob> => {
  // Configuración óptima para documentos con códigos de seguridad
  const settings = {
    quality: 0.85,       // Calidad alta para preservar códigos de barras y texto
    maxWidth: 2000,      // Ancho máximo para documentos A4
    maxHeight: 2828,     // Altura máxima proporcional A4 (√2 * maxWidth)
    format: 'image/jpeg', // Formato preferido
    // Umbral mínimo - no comprimir imágenes más pequeñas que esto
    minWidth: 800,       
    minHeight: 600
  };
  
  return new Promise((resolve, reject) => {
    // Crear objeto URL para la imagen
    const url = URL.createObjectURL(imageBlob);
    
    // Crear elemento de imagen
    const img = new Image();
    
    img.onload = () => {
      // Liberar URL del objeto
      URL.revokeObjectURL(url);
      
      let { width, height } = img;
      
      // Si la imagen ya es pequeña, mantener su tamaño original
      if (width <= settings.minWidth && height <= settings.minHeight) {
        console.log('La imagen ya es suficientemente pequeña, no se reducirá');
        if (imageBlob.type === settings.format) {
          // Si el formato ya es el deseado, retornar el blob original
          resolve(imageBlob);
          return;
        }
        // De lo contrario, seguir con la conversión de formato
      }
      
      // Calcular nuevas dimensiones manteniendo relación de aspecto
      if (width > settings.maxWidth) {
        height = Math.floor(height * (settings.maxWidth / width));
        width = settings.maxWidth;
      }
      
      if (height > settings.maxHeight) {
        width = Math.floor(width * (settings.maxHeight / height));
        height = settings.maxHeight;
      }
      
      // Crear canvas para la compresión
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      
      // Dibujar imagen en el canvas
      const ctx = canvas.getContext('2d');
      
      // Fondo blanco para asegurar que no haya transparencia
      ctx!.fillStyle = '#FFFFFF';
      ctx!.fillRect(0, 0, width, height);
      
      // Aplicar filtro de nitidez suave para mejorar la legibilidad después de la compresión
      ctx!.filter = 'contrast(1.05) saturate(1.02)';
      
      // Dibujar la imagen
      ctx!.drawImage(img, 0, 0, width, height);
      
      // Restablecer filtro
      ctx!.filter = 'none';
      
      // Convertir a Blob con la calidad especificada
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            reject(new Error('Error al comprimir la imagen'));
            return;
          }
          
          const originalSizeKB = Math.round(imageBlob.size / 1024);
          const newSizeKB = Math.round(blob.size / 1024);
          const savingPercent = Math.round(100 - (blob.size / imageBlob.size * 100));
          
          console.log(`Imagen optimizada: ${originalSizeKB}KB → ${newSizeKB}KB (ahorro: ${savingPercent}%)`);
          
          resolve(blob);
        },
        settings.format,
        settings.quality
      );
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Error al cargar la imagen para compresión'));
    };
    
    img.src = url;
  });
};